import type { FC, ReactElement, Ref } from 'react'
import { forwardRef } from 'react'
import { DialogProps, Dialog, Slide } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'

import '@dhl/theme'

const Transition = forwardRef((props: TransitionProps & { children: ReactElement }, ref: Ref<unknown>) => (
  <Slide direction="up" ref={ref} {...props} />
))

export const BottomDialog: FC<DialogProps> = ({ classes: propClasses, ...rest }) => (
  <Dialog
    classes={propClasses}
    slotProps={{
      transition: Transition,
      container: {
        sx: {
          flexDirection: 'column',
          justifyContent: 'flex-end',
        },
      },
      paper: {
        sx: (theme) => ({
          margin: 0,
          backgroundColor: theme.palette.common.white,
          borderRadius: 0,
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          width: '100% !important',
        }),
      },
    }}
    {...rest}
  />
)
